/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2023-04-08 00:00:00
 *
 *******************************************************/
// @flow

import React, { Component } from 'react';
import { Modal, Button } from '@shopify/polaris';
import { MobileCancelMajor } from '@shopify/polaris-icons';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';

type Props = {
  active: boolean,
  handleCancel: () => void,
  handleExplore: () => void
};

type ComposedProps = Props & WithI18nProps;
class PreLaunchPromotion0423Modal extends Component<ComposedProps> {
  render() {
    const { active, i18n } = this.props;
    return (
      <Modal
        open={active}
        onClose={this.handleCancel}
        titleHidden
        noScroll
        title={i18n.translate('AdminHTML.Dashboard.WelcomeNewFeature.merchandising_Title')}>
        <div className="PFS-Pre-launch-Modal">
          <div className="closeBtn">
            <Button onClick={this.handleCancel} icon={MobileCancelMajor} plain />
          </div>
          <div className="promotion-content">
            <p>{i18n.translate('AdminHTML.Common.Title.boost30')}</p>
            <p>{i18n.translate('AdminHTML.Common.Title.dateRelease')}</p>
          </div>

          {/* Explore button */}
          <div className="action">
            <Button primary size="large" onClick={this.handleExplore}>
              {i18n.translate('AdminHTML.Common.Action.sneakAPeek')}
            </Button>
          </div>
        </div>
      </Modal>
    );
  }

  handleCancel = () => {
    this.props.onClose();
  };

  handleExplore = () => {
    window.open('http://bit.ly/40lxAUd', '_blank');
  };
}

export default withI18n()(PreLaunchPromotion0423Modal);
